var exports = {
  "r2": "EditGroupModal.module__iconSection___b0xiUF",
  "go": "EditGroupModal.module__iconLabel___b0xiUF",
  "zc": "EditGroupModal.module__iconContainer___b0xiUF",
  "O2": "EditGroupModal.module__iconPreview___b0xiUF",
  "Pz": "EditGroupModal.module__iconPlaceholder___b0xiUF",
  "So": "EditGroupModal.module__iconPlaceholderIcon___b0xiUF",
  "D_": "EditGroupModal.module__iconActions___b0xiUF",
  "Rh": "EditGroupModal.module__iconButtonGroup___b0xiUF",
  "m5": "EditGroupModal.module__iconError___b0xiUF",
};

module.exports = exports;
